import React from "react";
import PropTypes from "prop-types";
import { Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles({
  root: {
    padding: "1rem 0",
  },
  title: {
    fontWeight: "600",
    fontSize: "18px",
  },
  subtitle: {
    fontWeight: "400",
    fontSize: "14px",
  },
});

export default function Title({ title, subtitle }) {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <Typography className={classes.title} variant='h5' component='h5'>
        {title}
      </Typography>
      <Typography
        className={classes.subtitle}
        variant='subtitle1'
        component='p'>
        {subtitle}
      </Typography>
    </div>
  );
}

Title.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
};
